import * as React from 'react';
import { useEffect, useState } from 'react';
import { get } from 'lodash';
import styles from './Verify.module.scss';
import { BounceLoader } from 'react-spinners';
import { RouteComponentProps, withRouter, Redirect } from 'react-router-dom';
import { RootState } from '../../store';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { meActions } from '../../store/me/actions';
import queryString from 'query-string';

interface DispatchProps {
  requestVerify: (token: string) => void;
}

interface StateProps {
  verifyToken: any;
  isVerifyLoading: any;
  isVerifyErroring: any;
}

type VerifyProps = StateProps & DispatchProps & RouteComponentProps;
export const Verify: React.FC<VerifyProps> = ({ location, requestVerify }) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const token = get(parsed, 'token', '');
    if (!token || token.length === 0) {
      setError(true);
    } else {
      requestVerify(token as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className={styles.container}>
      {!error && <BounceLoader color={'#27de81'} />}
      {error && <Redirect to="/verification-error"></Redirect>}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  verifyToken: state.me.verifyToken,
  isVerifyLoading: state.me.isVerifyLoading,
  isVerifyErroring: state.me.isVerifyErroring,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  requestVerify: bindActionCreators(meActions.verifyRequestAction, dispatch),
});
export const VerifyConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Verify),
);
